<template>
  <v-card flat>
    <v-card-title>
      Feedback
    </v-card-title>
    <v-card-text>
      <v-expansion-panels
        v-model="panel"
        accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header><b>Filters</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <presets-autocomplete
              @update="presetSelected"
            />
            <map-id-autocomplete
              v-model="map_id"
            />
            <v-autocomplete
              v-model="build_id"
              :items="builds"
              label="Build ID"
              background-color="grey lighten-2"
              class="pt-1"
              clearable
              hide-details
              dense
              solo
              flat
              item-text="build_id"
              item-value="build_id"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row class="mt-3">
        <v-col>
          <FeedbackChart />
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col>
          <FeedbackTable />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import PresetsAutocomplete from '../../components/filters/Telemetry/PresetsAutocomplete.vue';
import MapIdAutocomplete from '../../components/filters/Telemetry/MapIdAutocomplete.vue';
import FeedbackChart from '../../components/feedback-components/feedbackChart.vue'
import FeedbackTable from '../../components/feedback-components/feedbackTable.vue'
export default {
  components: {
    PresetsAutocomplete,
    MapIdAutocomplete,
    FeedbackChart,
    FeedbackTable
  },
  data () {
    return {
      panel: 0,
      builds: []
    }
  },
  created () {
    if (this.$route.query.map_id) {
      this.map_id = this.$route.query.map_id
    }

    if (this.$route.query.build_id) {
      this.build_id = this.$route.query.build_id
    }

    this.updateRouterQuery()
  },
  async mounted () {
    if (this.map_id || (this.$route.query.map_id === this.map_id && this.$route.query.map_id)) {
      await this.getSessions()
    }
  },
  watch: {
    async map_id (val) {
      if (val) {
        this.build_id = null
        this.updateRouterQuery()
        await this.getSessions()
      }
    },
    async build_id () {
      this.updateRouterQuery()
    }
  },
  computed: {
    map_id: {
      get () {
        return this.$store.state.telemetry.map_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_MAP_ID', val)
      }
    },
    build_id: {
      get () {
        return this.$store.state.telemetry.build_id
      },
      set (val) {
        this.$store.commit('telemetry/SET_BUILD_ID', val)
      }
    }
  },
  methods: {
    async getSessions () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/data-for-filters/${this.map_id}`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.builds = data
        if (this.$route.query.build_id) {
          this.build_id = this.$route.query.build_id
        } else if (data.length) {
          this.build_id = data[0].build_id
        }
      }
    },
    updateRouterQuery () {
      const flag = !(
        this.$route.query.map_id === this.map_id &&
        this.$route.query.build_id === this.build_id
      )

      if (flag) {
        this.$router.replace({
          path: "/telemetry/feedback",
          query: {
            map_id: this.map_id,
            build_id: this.build_id
          }
        })
      }
    },
    presetSelected ({ build_id, map_id }) {
      this.build_id = build_id
      this.map_id = map_id
    }
  }
}
</script>
